import React, { useMemo, useRef } from "react";
import { View, StyleSheet } from "react-native";
import NtModal from "./NtModal";
import NtDatePickerModal from "./NtDatePickerModal";
import NtText from "./NtText";
import NtTouchableEffect from "./NtTouchableEffect";
import NtModalInputTitle from "./NtModalInputTitle";
import { useTheme } from "../context/ThemeContext";
import {
  parseDisplayDate,
  parseSimpleDisplayDate,
} from "../common/utils/ControllerUtils";

function NtModalDatePickerField({
  containerStyle,
  title,
  placeholder,
  value,
  setValue,
  isTimeEnabled = false,
  renderAction = null,
}) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  const datePickerRef = useRef(null);

  const renderDatePickerModal = () => {
    return (
      <NtModal ref={datePickerRef}>
        <NtDatePickerModal
          date={value}
          isTimeEnabled={isTimeEnabled}
          onSelect={(date) => {
            setValue(date);
            datePickerRef.current?.dismiss();
          }}
          onCancel={() => {
            datePickerRef.current?.dismiss();
          }}
        />
      </NtModal>
    );
  };

  const formatDate = () => {
    if (value) {
      return isTimeEnabled ? parseDisplayDate(value) : parseSimpleDisplayDate(value);
    }
    return placeholder;
  };

  return (
    <View style={[styles.container, containerStyle]}>
      <NtModalInputTitle style={{ marginLeft: 4, marginBottom: 4 }}>
        {title}
      </NtModalInputTitle>
      <NtTouchableEffect
        style={styles.field}
        onPress={() => datePickerRef.current?.show()}
      >
        <NtText style={[styles.value, { color: value ? theme.text : theme.textMute }]}>
          {formatDate()}
        </NtText>
        {renderAction && renderAction}
      </NtTouchableEffect>
      {renderDatePickerModal()}
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    container: { marginBottom: 8 },
    field: {
      paddingHorizontal: 12,
      height: 38,
      backgroundColor: t.surface2,
      borderWidth: 1,
      borderColor: t.borderSoft,
      borderRadius: t.radius,
      flexDirection: "row",
      alignItems: "center",
    },
    value: {
      flex: 1,
      fontSize: 13,
      fontWeight: "500",
    },
  });

export default NtModalDatePickerField;
